export const completedSystemsData = [
    {
        id: 20,
        systemName: `Программное обеспечение искусственного интеллекта "Железный человек" Военно-воздушных сил Соединенных Штатов Америки`,
        applicant: "Военно-воздушные силы Соединенных штатов Америки",
        owner: "Военно-воздушные силы Соединенных штатов Америки",
        workType: 5,
        year: 2022,
        ContractType: "ПГЗ",
        conclusion: "Не соответствует",
        status: "Завершено",
        conclusionIndicator: "error",
        statusIndicator: "success"
    },
    {
        id: 19,
        systemName: `Геоинформационный портал земельного кадастра города Париж`,
        applicant: "Французская Республика",
        owner: "Французская Республика",
        workType: 4,
        year: 2022,
        ContractType: "ПГЗ",
        conclusion: "Не соответствует",
        status: "Завершено",
        conclusionIndicator: "error",
        statusIndicator: "success"
    },
    {
        id: 18,
        systemName: `Геоинформационный портал г.Милан`,
        applicant: "Итальянская Республика",
        owner: "Итальянская Республика",
        workType: 5,
        year: 2022,
        ContractType: "ПГЗ",
        conclusion: "Не соответствует",
        status: "Завершено",
        conclusionIndicator: "error",
        statusIndicator: "success"
    },
    {
        id: 17,
        systemName: `Программное обеспечение "Конор Макгрегор"`,
        applicant: "Соединенное королевство Великобритании и Северной Ирландии",
        owner: "Соединенное королевство Великобритании и Северной Ирландии",
        workType: 4,
        year: 2022,
        ContractType: "не ПГЗ",
        conclusion: "Не соответствует",
        status: "Завершено",
        conclusionIndicator: "error",
        statusIndicator: "success"
    },
    {
        id: 16,
        systemName: "Интернет-портал Systems",
        applicant: "АО ГТС",
        owner: "АО ГТС",
        workType: 5,
        year: 2022,
        ContractType: "не ПГЗ",
        conclusion: "Соответствует",
        status: "Завершено",
        conclusionIndicator: "success",
        statusIndicator: "success"
    },
    {
        id: 15,
        systemName: `Программное обеспечение "Железный человек"`,
        applicant: "ВС США",
        owner: "ВС США",
        workType: 5,
        year: 2022,
        ContractType: "ПГЗ",
        conclusion: "Не соответствует",
        status: "Завершено",
        conclusionIndicator: "error",
        statusIndicator: "success"
    },
    {
        id: 14,
        systemName: `Геоинформационный портал г. Париж`,
        applicant: "Французская Республика",
        owner: "Французская Республика",
        workType: 4,
        year: 2022,
        ContractType: "ПГЗ",
        conclusion: "Не соответствует",
        status: "Завершено",
        conclusionIndicator: "error",
        statusIndicator: "success"
    },
    {
        id: 13,
        systemName: `Геоинформационный портал г.Милан`,
        applicant: "Итальянская Республика",
        owner: "Итальянская Республика",
        workType: 5,
        year: 2022,
        ContractType: "ПГЗ",
        conclusion: "Не соответствует",
        status: "Завершено",
        conclusionIndicator: "error",
        statusIndicator: "success"
    },
    {
        id: 12,
        systemName: `Программное обеспечение "Конор Макгрегор"`,
        applicant: "Соединенное королевство Великобритании и Северной Ирландии",
        owner: "Соединенное королевство Великобритании и Северной Ирландии",
        workType: 4,
        year: 2022,
        ContractType: "не ПГЗ",
        conclusion: "Не соответствует",
        status: "Завершено",
        conclusionIndicator: "error",
        statusIndicator: "success"
    },
    {
        id: 11,
        systemName: "Интернет-портал Systems",
        applicant: "АО ГТС",
        owner: "АО ГТС",
        workType: 5,
        year: 2022,
        ContractType: "не ПГЗ",
        conclusion: "Соответствует",
        status: "Завершено",
        conclusionIndicator: "success",
        statusIndicator: "success"
    },
]